<h1 mat-dialog-title>{{ title }}</h1>
<main mat-dialog-content>
  <div>
    <ejs-textbox
      required
      [placeholder]="'Name'"
      [formControl]="name"
      [floatLabelType]="'Auto'"
      [maxlength]="50"
      [cssClass]="name?.invalid && (name?.touched || name?.dirty) ? 'e-bigger e-error' : 'e-bigger'"
    ></ejs-textbox>
    <div class="e-error" *ngIf="name.hasError('required')">Name is required.</div>
    <div class="e-error" *ngIf="name.hasError('duplicateName')">Name must be unique.</div>
  </div>
  <div *ngIf="showDescription">
    <ejs-textbox
      [placeholder]="'Description'"
      [formControl]="description"
      [floatLabelType]="'Auto'"
      [maxlength]="100"
      [cssClass]="'e-bigger'"
    ></ejs-textbox>
  </div>
</main>
<div mat-dialog-actions>
  <button appButton accent type="submit" [disabled]="name.invalid" (click)="onSave()">
    {{ actionName }}
  </button>
  <button appButton primary link mat-dialog-close>Cancel</button>
</div>
